﻿import * as eventTypes from '../../../map/utils/eventTypes';
import * as geomTypes from '../../../map/utils/geomTypes';
import * as layerTypes from '../../../map/utils/layerTypes';
import NominatimSearch from './NominatimSearch';
import CoordinateSearch from './CoordinateSearch';
export default class QuickSearchControl {
    constructor(resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, config) {
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.elementId = 'map-search-' + this.classId;
        this.active = false;
        this.origConfig = config;
        this.config = [];
        this.searchDataSourceList = [];
        this.coordinateSearch = new CoordinateSearch(mapControl, resourcesHandler);
    }

    init() {
        if (this.origConfig.length > 0) {
            this.origConfig.forEach(item => {
                if (!item.Name.indexOf('*') == 0) {
                    this.config.push(item);
                }
            });
        }

        if (this.config.length == 0) {
            return;
        }

        this._createSearchControl();
    }

    _createSearchControl() {
        this.menuContainer.append(
            '<div class="map-search d-flex shadow-1" style="display:none;">'
            + '<div class="input-group-prepend">'
            + '<button title="' + this.resourcesHandler.get('Search Config') + '" class="btn btn-default btn-icon waves-effect waves-themed map-serach-config" type="button" style="border-radius: 4px 0 0 4px " > <i class="ni ni-menu"></i></button>'
            + '</div>'
            + '<input type="text" id="' + this.elementId + '" style="width:100%;"></input>'
            + '</div>'
        );

        var ref = this;
        $("#" + this.elementId).kendoComboBox({
            placeholder: this.resourcesHandler.get("Search"),
            dataTextField: "Name",
            dataValueField: "Name",
            filter: "contains",
            autoBind: false,
            suggest: true,
            delay: 1000,
            dataSource: {
                serverFiltering: true,
                filter: [],
                transport: {
                    //CG: cautarile server (SQL) si Nominatim ruleaza in paralel; ordinea: coordonate, Nominatim, server
                    read: (options) => {
                        let combo = $("#" + this.elementId).data("kendoComboBox");
                        let criteria = combo.input.val() || '';

                        if (combo.dataItem() == null || combo.dataItem().Name != criteria) {
                            this.mapControl.showSearchResult(null, null, null);
                        }

                        let enabledIds = this.searchDataSourceList.filter(x => x.Enabled).map(x => x.Id);
                        let nominatimSearches = this.config.filter(x => NominatimSearch.isNominatim(x) && enabledIds.includes(x.Id));

                        let serverRequest = $.ajax({
                            type: "GET",
                            url: this.rootURL + "Map/MapSearch",
                            data: {
                                searchText: removeDiacritics(criteria),
                                idMap: this.mapControl.mapId,
                                idMapSearch: JSON.stringify(enabledIds)
                            }
                        }).then(resp => Array.isArray(resp) ? resp : (resp?.data || []), () => []);

                        let nominatimRequests = criteria.trim().length >= 3
                            ? nominatimSearches.map(x => new NominatimSearch(x).search(criteria))
                            : [];

                        let coordinateRows = this.coordinateSearch.search(criteria);

                        //CG: ignor raspunsurile unei cautari mai vechi, sosite dupa una mai noua
                        let requestNo = this.searchRequestNo = (this.searchRequestNo || 0) + 1;
                        Promise.all([coordinateRows, ...nominatimRequests, Promise.resolve(serverRequest)])
                            .then(results => requestNo == this.searchRequestNo && options.success(results.flat()))
                            .catch(err => requestNo == this.searchRequestNo && options.error(err));
                    }
                }
            },
            filtering: (e) => {
                var filterValue = e.filter ? e.filter.value : "";

                if (filterValue.length < 3) {
                    e.preventDefault();
                }
            },
            template: '<div class="d-flex"><div><span class="#: IconClass# pl-1 pt-1 pr-3" style="font-size:2rem;"> </span></div><div class="d-flex-column"><div class="color-primary" style="font-weight:400" >#: Name # </div><div>#: DataSourceName #</div></div></div>',
            noDataTemplate: (e) => {
                return this.resourcesHandler.get("No data found");
            },
            change: (e) => {
                this._showItem(e.sender.dataItem());
            },
            close: (e) => {
                let item = e.sender.dataItem();
                this._showItem(item != null && item.Name == e.sender.value() ? item : null);
            }
        });
        $(".map-search .k-select").addClass("bg-primary");
        $(".map-search .k-select").addClass("text-white");
        $(".map-search .k-select .k-icon").removeClass("k-i-arrow-60-down");
        $(".map-search .k-select .k-icon").addClass("k-i-search");

        this._createSearchConfigControlPanel();
        $(".map-serach-config").click(this._handleSearchConfigClickEvent());

        $(".map-search").show();
    }

    _showItem(item) {
        if (item == null) {
            this.mapControl.showSearchResult(null, null, null);
            return;
        }

        if (item.Type == 'COORDINATE') {
            this.mapControl.showSearchResult(this.coordinateSearch.toMapWkt(item), null, null);
            return;
        }

        let dsConfig = this.config.find(x => x.Id == item.IdMapSearch);
        let styleId = dsConfig?.IdStyle;
        let minScale = dsConfig?.MinScale;

        if (item.Type == 'NOMINATIM') {
            this.mapControl.showSearchResultBBox(item.Wkt, item.Lat, item.Lon, styleId, minScale);
        } else {
            this.mapControl.showSearchResult(item.Wkt, styleId, minScale);
        }
    }

    _createSearchConfigControlPanel() {
        this.menuContainer.append(
            '<div class="js-modal-search-config" style="display:none;">'
            + '<div class="js-modal-search-config-header border-faded border-bottom-1 d-flex justify-content-left align-items-center pl-4" style="height:62px; position:relative;">'
            + '<h4 class="m-0 text-center " style="color:#212529;">'
            + this.resourcesHandler.get('Search Config')
            + '</h4>'
            + '<button style="color:#212529;" type="button" class="close  position-absolute pos-top pos-right p-2 m-1 mr-2"  title="' + this.resourcesHandler.get('Close') + '">'
            + '<span aria-hidden="true"><i class="fal fa-times"></i></span>'
            + '</button>'
            + '</div>'
            + '<div class="js-modal-search-config-body mt-2 mb-2 ml-3 mr-3" style="height:auto; position:relative;">'
            + '<div class="searchConfig"></div>'
            + '</div>'
            + '</div>'
        );

        this.menuContainer.find(".js-modal-search-config .close").click( () => {
            this.menuContainer.find(".js-modal-search-config").removeClass("show");
            this.menuContainer.find(".js-modal-search-config").hide();
        });

        this._createSearchConfigTree();
    }

    _handleSearchConfigClickEvent() {
        var clickHandler = () => {
            this.menuContainer.find(".js-modal-search-config").show();
            this.menuContainer.find(".js-modal-search-config").addClass("show");
        }

        return clickHandler;
    }

    _createSearchConfigTree() {
        this.searchDataSourceList = [];
        for (var i = 0; i < this.config.length; i++) {
            if (!this.config[i].Name.indexOf('*') == 0) {
                this.searchDataSourceList.push({
                    Name: this.resourcesHandler.get(this.config[i].Name),
                    Icon: this.config[i].Icon,
                    Id: this.config[i].Id,
                    Enabled: true
                });
            }
        }

        this.menuContainer.find(".searchConfig").kendoTreeView({
            loadOnDemand: false,
            dataSource: this.searchDataSourceList,
            dragAndDrop: false,
            template: '<div class="search-node" style="width: 100 %;" data-search-id="#: item.Id #">'
                + ' <div class= "custom-control custom-switch" style = "cursor: pointer !important;" >'
                + '<input type="checkbox" class="custom-control-input" id="search-nod-#:item.Id#" checked="" style="cursor: pointer !important;">'
                + '<label class="custom-control-label" for="search-nod-#:item.Id#" style="cursor: pointer !important;">#: item.Name#</label>'
                + '</div>'
                + ' </div>',
            select: (e) => {
                e.preventDefault();
            }
        });

        for (var i = 0; i < this.searchDataSourceList.length; i++) {
            $("#search-nod-" + this.searchDataSourceList[i].Id).change(this._getSwitchHandler(this.searchDataSourceList[i].Id));
        }

        this.menuContainer.find(".searchConfig").data("kendoTreeView").expand(".k-treeview-item");
    }

    _getSwitchHandler(dataSourceId) {
        var handler = () => {

            for (var i = 0; i < this.searchDataSourceList.length; i++) {
                if (this.searchDataSourceList[i].Id == dataSourceId) {
                    this.searchDataSourceList[i].Enabled = !this.searchDataSourceList[i].Enabled;
                }

                $("#" + this.elementId).data("kendoComboBox").dataSource.read();
            }
        }

        return handler;
    }
}